import { useMutation } from '@tanstack/react-query'

import type { ApiError } from '@/lib/api/errors'
import { createCampaign } from '@/lib/venue/campaignApi'
import type { VenueCampaignCreateInput, VenueCampaignDetailView } from '@/lib/venue/campaignTypes'

/**
 * 공지 작성(#714 §1-1) — "발송 확인 모달" 흐름의 1단계.
 * 🚨 여기서 목록·요약 쿼리를 무효화하지 않는다 — 작성만으로는 아직 `SENT`가 아니라 관리 홈·이력에
 * 노출할 만한 상태 변화가 없다(무효화는 `useSendCampaign` 성공 시에만, 설계 §자율 결정 3).
 */
export function useCreateCampaign(venueId: string) {
  return useMutation<VenueCampaignDetailView, ApiError, VenueCampaignCreateInput>({
    mutationFn: (input) => createCampaign(venueId, input),
  })
}
